exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-page-outer-conterner{width:100%;min-height:88vh}.api-key-container{resize:none}.dash-key-inner-container{width:100%}.dash-key-inner-container .highlight-link{color:#5f8f93!important}.category-wrapper-substitute{padding:2% 14%}.dash-account .btn{color:#fff;border-radius:10px}.dash-container{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify!important;justify-content:space-between!important;-ms-flex-align:sretch;align-items:sretch;min-height:72vh}.dash-container .dash-title{text-align:center;border-bottom:1px solid #5f8f93}.dash-container .dash-title h1{font-size:4rem}.deactivate-dialog-container{border:1px solid #d9534f;border-radius:10px;padding-bottom:10px}@media screen and (min-width:992px){.dashboard .col-md-8{margin-top:9px}}.dashboard__monthly-usage{margin-bottom:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/dashboard.styl
// module id = 491
// module chunks = 0